<template>
  <span v-if="showSelectSearch">
    <b-form-group
      v-if="!localDataLoad"
      label="Search"
    >
      <b-form-input
        v-model="LocalSearch"
        placeholder="Search..."
        class="w-100"
        @input="$emit('handleSearchOnly', LocalSearch)"
      />
    </b-form-group>
  </span>
</template>

<script>

export default {
  props: {
    showSelectSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      LocalSearch: '',
      localDataLoad: false,
    }
  },
  watch: {
    '$route.query.search': {
      immediate: true,
      handler(newVal) {
        this.LocalSearch = newVal || ''
      },
    },
  },
}
</script>
